import React, { Component } from "react";

import { Button,Jumbotron,Tabs,Tab,Badge,Table,FormGroup, Col,Form, FormControl,ControlLabel,Checkbox,Label,Well,ButtonToolbar,ToggleButton,ToggleButtonGroup} from "react-bootstrap";
import { API } from "aws-amplify";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignInAlt,faSignOutAlt,faShieldAlt ,faCogs,faDoorClosed} from '@fortawesome/free-solid-svg-icons'

import Moment from 'react-moment';
import moment from "moment"
import { CSVLink, CSVDownload } from "react-csv";
const log = (type) => console.log.bind(console, type);


var regnum=new RegExp(/^\+44\d{10,10}$/)

function accessState(s){
  if(s=="Y"){
    return true
  }
  return false
}
function border_mark_class(d){

  if (d.checked_out==false)
  return "amber_left_border"

  return "green_left_border"
}


function numplate(plate){
  if(plate.length>0)
    return(<span className="number_plate">{plate}</span>)

}

function formatTime(time,long=false){
  try{
  let t=new Date(time)
  let today=new Date()


  let timestr=""


  if(t.toDateString()==today.toDateString() && long==false){
    return t.toTimeString().substr(0,5)
  }

  return t.getUTCDate()+"/"+(t.getMonth()+1)+"/"+t.getUTCFullYear()+" "+t.toTimeString().substr(0,5)
  }
  catch(err){
    return time
  }
}

function Chip(props){

  return (<Badge>{props.label}</Badge>)


}


export default class DoorControl extends Component {
  constructor(props) {
  super(props);
  this.state = {
    data:[],
    hist_data:[],
    history_date_to:"",
    history_date_from:"",
    record_active:false,
    record:{}
};
}

onTextChange=(event)=>{
      console.log(event.target.value)
      this.setState({messageInput:event.target.value})
}

async componentDidMount() {
  /* fetch('https://api.myjson.com/bins/'+this.props.match.params.id)
     .then(response => response.json())
     .then(data => this.setState({ form:data }));
     */

     //const request_status = await fetch(server+'/api?type=door&cmd=status')
     //const data = await request_status.json();

   const responce=await this.getData("door");

   //const data=await responce.json()
    console.log(responce)
    this.setState({data:responce.result})
  //   this.setState({...responce})
  //   console.log(this.state)
//     this.generateCSV()
 }





 handleChange = event => {
   this.setState({
     [event.target.id]: event.target.value
   });
 }

generateCSV(){



  let tempCSV=[["Date Time","Number","Name","District","Area","Hours","RAW"]]

  for (var i=0;i<this.state.data.length;i++){
      tempCSV.push([moment(this.state.data[i].date.$date).format('YYYY-MM-DD HH:mm:ss'),"'"+this.state.data[i].number+"'",this.state.data[i].name,this.state.data[i].district,this.state.data[i].location,this.state.data[i].hours,this.state.data[i].raw])
  }
  console.log(tempCSV)
  this.setState({csvData:tempCSV})

}



 async sendData(parameters){
   let data = {
     'queryStringParameters': parameters
   }
   return API.get("AltiomData", "/forms/",data);
 }


 async getData(cmd){
   let data = {
     'queryStringParameters': {
         'cmd': cmd,
         'group':this.props.match.params.id
     }
   }
   return API.get("AltiomData", "/forms/",data);
 }
 async getHistoryData(cmd,from,to){
   let data = {
     'queryStringParameters': {
         'cmd': cmd,
         'group':this.props.match.params.id,
         'date':from,
         'date_to':to
     }
   }
   return API.get("AltiomData", "/forms/",data);
 }

/* updateMessage = async event=>{
   this.setState({feedback:"saving..."})
   let d={
     "cmd":"updateMessage",
     "message":this.state.messageInput,
     "group":this.props.match.params.id
   }
   let responce=await this.sendData(d)
//   this.setState({...responce})
    this.setState({feedback:"saved"})


 }*/


  checkNumber = async event => {

   console.log("Check number")

   if(this.state.new_number.match(regnum)!=null){
     console.log("Valid Number")

   }else{
     alert("Please Check mobile format, Should be +44xxxxxxxxxx")
     return
   }

   if(this.state.new_name.length==0){
     alert("Please provide a name!")
     return
   }

   let d={
     "cmd":"addNumber",
     "mobile":this.state.new_number,
     "name":this.state.new_name,
     "group":this.props.match.params.id
   }
   let responce=await this.sendData(d)
   this.setState({...responce})

 }

deleteNumbyId=async id=>{

  console.log("Delete "+id)
  let d={
    "cmd":"deleteNumbyId",
    "id":id,
    "group":this.props.match.params.id
  }
  let responce=await this.sendData(d)
  this.setState({...responce})

}

hightlight=(id)=>{
  console.log(id)
  this.setState({"hightlight":id})
}

changeState=async (index,value)=>{
  console.log("Button change")
  console.log(value)
  let temp=this.state.districts[index]
  temp.enabled=value
  //this.setState({districts:temp})
  let d={
    "cmd":"saveDistricts",
    "group":this.props.match.params.id,
    "data":JSON.stringify(temp)
  }
  let responce=await this.sendData(d)
  this.setState({...responce})

  }



  districtDelete=async (index)=>{
    let temp=this.state.districts[index]
    let d={
      "cmd":"deleteDistricts",
      "group":this.props.match.params.id,
      "data":JSON.stringify(temp)
    }
    let responce=await this.sendData(d)
    this.setState({...responce})

  }



districtEdit=(index)=>{
  if(this.state.editIndex!=-1){
    this.cancelEdit()
  }
  this.setState({"editIndex":index})
}

removeMatch=(index,m_index)=>{
  console.log("remove")
  console.log(index)
  console.log(m_index)
  let temp=this.state.districts
  console.log("remove:"+temp[index].match[m_index])
  temp[index].match.splice(m_index,1)
  console.log(temp)
  this.setState({districts:temp})
}

removePostcode=(index,p_index)=>{
  console.log("remove")
  console.log(index)
  console.log(p_index)
  let temp=this.state.districts
  console.log("remove:"+temp[index].postcodes[p_index])
  temp[index].postcodes.splice(p_index,1)
  console.log(temp)
  this.setState({districts:temp})
}

addPostcode=()=>{
  console.log("Add postcode")
  let temp=this.state.districts
  if(this.state.new_postcode.length>0){
    temp[this.state.editIndex].postcodes.push(this.state.new_postcode)
  }
  this.setState({new_postcode:""})
  this.setState({districts:temp})
}

addMatch=()=>{
  console.log("Add match")
  let temp=this.state.districts
  if(this.state.new_match.length>0){
    temp[this.state.editIndex].match.push(this.state.new_match.toLowerCase())
  }
  this.setState({new_match:""})
  this.setState({districts:temp})
}

nameChange=(event)=>{
  let temp=this.state.districts
  temp[this.state.editIndex].name=event.target.value
  this.setState({districts:temp})
}


saveDistrict=async ()=>{
  let temp=this.state.districts[this.state.editIndex]
  console.log(JSON.stringify(temp))
  let d={
    "cmd":"saveDistricts",
    "group":this.props.match.params.id,
    "data":JSON.stringify(temp)
  }
  let responce=await this.sendData(d)
  this.setState({...responce})
    this.setState({editIndex:-1})
}


hightlightON(d){
  if(d.location==this.state.hightlight)
      return "highligttext"

  if(d.district==this.state.hightlight)
    return "highligttext"


  return "nohighlight"


}

hightlightSort(d){

  if(d==this.state.sortmode){
    return "bolder"
  }
  return ""


}


hightlightONT(d){
  if(d.location==this.state.hightlight)
      return "*"

  if(d.district==this.state.hightlight)
    return "*"






  return ""


}


cancelEdit= async e=>{

  //request a copy of district data from the server
  this.setState({editIndex:-1})
  let d={
    "cmd":"getDistricts",
    "group":this.props.match.params.id
  }
  let responce=await this.sendData(d)
  this.setState({...responce})
}

newDistrict=()=>{
  let blank={
      "name":"new",
      "enabled":true,
      "group":this.props.match.params.id,
      "postcodes":[],
      "match":[]
  }
  let temp=this.state.districts
  temp.push(blank)
  this.setState({districts:temp})
  this.setState({editIndex:temp.length-1})



}

show_detail=(entry)=>{
  this.setState({record:entry})
  this.setState({record_active:true})
  setTimeout(() => {
    window.scrollTo({
      behavior: document.getElementById("show_detail") ? "smooth" : "auto",
      top: document.getElementById("show_detail") ? document.getElementById("show_detail").offsetTop : 0
    });
  }, 100);

}

data_sort=(a,b)=>{

  let sA=a[this.state.sortmode]
  let sB=b[this.state.sortmode]
  if(this.state.sortmode=="date"){
    sA=a.date.$date
    sB=b.date.$date
  }


  if(sA<sB){
    if(this.state.sortmodereverse==true)
      return 1
    return -1
  }
  if(sA>sB){
    if(this.state.sortmodereverse==true)
      return -1
    return 1
  }
  return 0
}
changeDateFrom=async(event,value)=>{
  console.log("change date from")
  this.setState({history_date_from:event.target.value})
  let d=await this.getHistoryData("doorhist",event.target.value,this.state.history_date_to);
  console.log(d)
  this.setState({hist_data:d.result})
}

changeDateTo=async(event,value)=>{
  console.log("change date to")
  this.setState({history_date_to:event.target.value})
  let d=await this.getHistoryData("doorhist",this.state.history_date_from,event.target.value);
  console.log(d)
  this.setState({hist_data:d.result})
}




changeSort=(key)=>{
  console.log(key)
  if(key==this.state.sortmode){
    console.log(this.state.sortmodereverse)
    this.setState({sortmodereverse:!this.state.sortmodereverse})
  }
  this.setState({sortmode:key})
}

  render() {
    return (
      <Jumbotron>

          <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
          <Tab eventKey={1} title="Current State">

          <h4>Summary -<i> Whos in building</i></h4>
          <Well>


          <div>
          {this.state.data.map((entry,index)=>{

            if(entry.checked_out==true && this.state.show_all==false){
              return("")
            }

            return(<div>
              <div elevation={1} className="flex flexrow flex_between textleft margin_all grey_border boot_paper">
              <div className={border_mark_class(entry)+" minw200 padtb" }>




              <span variant="body1" color="inherit">
  {entry.visitor==true ?("Visitor:"+entry.name):(entry.name)}
  {entry.number_plate!=undefined ?(numplate(entry.number_plate)):("")}

              </span>



  </div>


              <div className="minw300 padtb">
              <span variant="body1" color="inherit" className="textleft">

              <div className="pt2px">
                  {"checkin_time" in entry ?(<Chip
                  avatar={<FontAwesomeIcon icon={faSignInAlt} />}
                  label={"IN "+formatTime(entry.checkin_time.$date)}
                  variant="outlined"
                  />):(<div className="blank_gap"></div>)}
                  </div>
                  &nbsp;
                  {entry.checked_out==true ? (<Chip
                      avatar={<FontAwesomeIcon icon={faSignOutAlt} />}
                      label={"OUT "+formatTime(entry.checkout_time.$date)}
                      variant="outlined"/>
                    ):("")}
                    &nbsp;
                    {entry.checked_out==false ? ( <Moment interval={1000} date={entry.checkin_time.$date}  fromNow  />):("")}
              </span>
              </div>

              <div>
              {/*  <button onClick={()=>this.openDetails(entry)}>View Details</button>*/}
              </div>


              </div>
            </div>)



          })}
          </div>

          </Well>


          </Tab>

          <Tab eventKey={2} title="History">

                    <h4><i> Select a date</i></h4>

                    <div style={{"display":"flex"}}>
                    <div>
                        From:
                        <input key="date1" type="date" value={this.state.history_date_from} onChange={this.changeDateFrom}/>
                    </div>
                    <div>
                        To:
                        <input key="date2" type="date" value={this.state.history_date_to} onChange={this.changeDateTo}/>
                    </div>
              </div>


          <Well>

                    <div>
                    {this.state.hist_data.map((entry,index)=>{

                      if(entry.checked_out==true && this.state.show_all==false){
                        return("")
                      }

                      return(<div>
                        <div elevation={1} className="flex flexrow flex_between textleft margin_all grey_border boot_paper">
                        <div className={border_mark_class(entry)+" minw200 padtb" }>




                        <span variant="body1" color="inherit">
            {entry.visitor==true ?("Visitor:"+entry.name):(entry.name)}
            {entry.number_plate!=undefined ?(numplate(entry.number_plate)):("")}

                        </span>



            </div>


                        <div className="minw300 padtb">
                        <span variant="body1" color="inherit" className="textleft">

                        <div className="pt2px">
                            {"checkin_time" in entry ?(<Chip
                            avatar={<FontAwesomeIcon icon={faSignInAlt} />}
                            label={"IN "+formatTime(entry.checkin_time.$date)}
                            variant="outlined"
                            />):(<div className="blank_gap"></div>)}
                            </div>
                            &nbsp;
                            {entry.checked_out==true ? (<Chip
                                avatar={<FontAwesomeIcon icon={faSignOutAlt} />}
                                label={"OUT "+formatTime(entry.checkout_time.$date)}
                                variant="outlined"/>
                              ):("")}
                              &nbsp;
                              {entry.checked_out==false ? ( <Moment interval={1000} date={entry.checkin_time.$date}  fromNow  />):("")}
                        </span>
                        </div>

                        <div className="padtb">
                        {"entries" in entry ?(<span><a onClick={()=>this.show_detail(entry)}>{entry.entries.length} Entries&nbsp;</a></span>):("")}
                        {/*  <button onClick={()=>this.openDetails(entry)}>View Details</button>*/}
                        </div>


                        </div>
                      </div>)



                    })}
                    </div>

          </Well>


          {this.state.record_active==true ?
          (<Well id="show_detail">



          <table className="textleft" >
              <tr><th>Name:</th><td>{this.state.record.name}</td></tr>
              <tr><th>Card No:</th><td>{this.state.record.card_id}</td></tr>
          </table>
          <br/>
          <br/>
          <div className="markdown-body">
          <center><table width="100%">
              <tr><th>IN</th><th>OUT</th></tr>
                  {this.state.record.entries.map((entry,index)=><tr>

                        <td className="textright">
                          {entry.checked_in==true ? (formatTime(entry.checkin_time.$date,true)):("")}
                        </td>
                        <td className="textleft">
                          {entry.checked_out==true ? (formatTime(entry.checkout_time.$date,true)):("")}
                        </td>





              </tr>)}


                            </table></center>
                            </div>

          </Well>):("")}

        </Tab>



{/*        <Tab eventKey={3} title="Users">
            <h3>Cards and users</h3>
            <Well>


            </Well>
        </Tab>
*/}
        </Tabs>




        </Jumbotron>

    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Door/DoorControl.js